import type { Attachment } from '@/types/chat'

export function getFileType(file: File): string {
  const t = file.type
  if (t.startsWith('image/')) return 'image'
  if (t.startsWith('audio/')) return 'audio'
  if (t.startsWith('video/')) return 'video'
  return 'file'
}

export async function fileToBase64(file: File): Promise<string> {
  const buffer = await file.arrayBuffer()
  const bytes = new Uint8Array(buffer)
  let binary = ''
  for (let i = 0; i < bytes.byteLength; i++) binary += String.fromCharCode(bytes[i])
  return btoa(binary)
}

export function isVideo(att: Attachment): boolean {
  if (att.file_type === 'video') return true
  if (att.content_type?.startsWith('video/')) return true
  return ['mp4', 'webm', 'mov', 'avi', 'mkv', 'ogg'].includes(att.extension?.toLowerCase() || '')
}

export function isPdf(att: Attachment): boolean {
  return att.extension === 'pdf' || att.content_type === 'application/pdf'
}

export function fmtSize(bytes?: number): string {
  if (!bytes) return ''
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1048576) return `${(bytes / 1024).toFixed(1)} KB`
  return `${(bytes / 1048576).toFixed(1)} MB`
}

export function extractFileKey(content: string): string | null {
  const m = content.match(/(?:📁 Arquivo enviado:|📄 Estamos preparando seu arquivo:)[\r\n ]*(\S+)/)
  if (!m) return null
  return m[1].replace(/[.…]+$/, '').trim()
}
